<template>
	<v-container
		v-if="targets.levels.length"
		class="main"
		d-flex
		justify-center
	>
		<v-card flat tile color="transparent" max-width="414">
			<v-window v-model="currentLevel">
				<v-window-item
					v-for="level in targets.levels"
					:key="`card-${level.levelId}`"
					disabled
					transition="false"
					reverse-transition="false"
				>
					<v-card class="main-card" flat tile color="transparent">
						<div class="card-content">
							<div class="level">
								<div class="level-number">
									{{ level.levelNumber }}
								</div>
								<div class="level-text">Level</div>
							</div>
							<div class="recharge-info">
								<div class="recharge-info-text">
									Recharge &#8377;{{ level.endAmount }}
									<div class="recharge-tagline">
										Do a recharge of &#8377;{{
											level.endAmount
										}}
										and get &#8377;{{ level.rewardAmount }}
										extra rewards
									</div>
									<div
										class="recharge-info-bar"
										v-if="level.status === 'INPROGRESS'"
									>
										&#8377;{{ level.currentAmount }}
										Recharged
										<v-progress-linear
											class="progress-bar"
											:value="
												(level.currentAmount * 100) /
													(level.endAmount -
														level.startAmount)
											"
											height="5"
											color="#ED7350"
											background-color="#EDF0F7"
										></v-progress-linear>
									</div>
									<div
										class="recharge-completed"
										v-else-if="level.status === 'COMPLETED'"
									>
										Yay! You have earned this reward
									</div>
									<div v-else class="recharge-info-bar">
										Complete Level
										{{ level.levelNumber - 1 }} to unlock
										<v-progress-linear
											class="progress-bar"
											:value="0"
											height="5"
											background-color="#EDF0F7"
										></v-progress-linear>
									</div>
								</div>
							</div>

							<div class="rewards">
								<div
									class="time-left dark"
									v-if="level.status !== 'COMPLETED'"
								>
									<v-icon size="10" dark>timer</v-icon>
									<span>&nbsp;{{ endTimeLeft }}</span>
								</div>
								<div class="achieved dark" v-else>Achieved</div>
								<div class="rewards-amount-container">
									<div>Rewards</div>
									<div class="amount">
										<span class="inr-symbol">&#8377;</span>
										<span class="amount-value">{{
											level.rewardAmount
										}}</span>
									</div>
								</div>
								<button
									class="recharge-button"
									v-if="level.status === 'INPROGRESS'"
									@click="transferJeet11"
								>
									Recharge
								</button>
							</div>
						</div>
					</v-card>
				</v-window-item>
			</v-window>

			<v-card-actions class="card-actions justify-space-between">
				<button class="navigate-button" @click="goToPrevLevel">
					<v-icon>chevron_left</v-icon>
				</button>
				<v-item-group
					v-model="currentLevel"
					class="text-xs-center"
					mandatory
				>
					<v-item
						v-for="n in targets.levels.length"
						:key="`window-dot-${n}`"
					>
						<v-btn
							class="window-dot"
							:class="{
								active: active,
								inactive: !active
							}"
							slot-scope="{ active, toggle }"
							:input-value="active"
							icon
							@click="toggle"
						>
						</v-btn>
					</v-item>
				</v-item-group>
				<button class="navigate-button" @click="goToNextLevel">
					<v-icon>chevron_right</v-icon>
				</button>
			</v-card-actions>
		</v-card>
	</v-container>
</template>

<script>
import { mapState } from "vuex";
import { FETCH_CAPTAIN_TARGETS } from "@/store/action-types";
export default {
	mounted() {
		// this.fetchCaptainTargets();
		setInterval(() => {
			this.currentTime = Date.now();
		}, 60000);
	},
	computed: {
		...mapState({
			targets: state => state.jeet11.jeet11CaptainTargets
		}),
		endTimeLeft() {
			// get total seconds between the times
			const date_future = new Date(this.targets.endTime).getTime();
			if (date_future < this.currentTime) return "0m";
			return this.duration(this.currentTime, date_future);
		}
	},
	data: () => ({
		currentLevel: 0,
		currentTime: Date.now()
	}),
	props: ["transferJeet11"],
	methods: {
		duration(date1, date2) {
			let delta = Math.abs(date2 - date1) / 1000;
			const days = Math.floor(delta / 86400);
			delta -= days * 86400;
			const hours = Math.floor(delta / 3600) % 24;
			delta -= hours * 3600;
			const minutes = Math.floor(delta / 60) % 60;
			delta -= minutes * 60;
			let duration;
			if (days) duration = days + "d " + hours + "h " + minutes + "m ";
			else if (hours) duration = hours + "h " + minutes + "m ";
			else duration = minutes + "m ";
			return duration;
		},
		fetchCaptainTargets() {
			this.$store.dispatch(FETCH_CAPTAIN_TARGETS.dispatch).then(() => {
				this.goToInProgressLevel();
			});
		},
		goToNextLevel() {
			this.currentLevel =
				this.currentLevel + 1 === this.targets.levels.length
					? 0
					: this.currentLevel + 1;
		},
		goToPrevLevel() {
			this.currentLevel =
				this.currentLevel - 1 < 0
					? this.targets.levels.length - 1
					: this.currentLevel - 1;
		},
		goToInProgressLevel() {
			if (
				this.targets &&
				this.targets.levels &&
				this.targets.levels.length
			) {
				let newLevel = this.currentLevel;
				for (let levelIndex in this.targets.levels) {
					if (
						this.targets.levels[levelIndex].status === "INPROGRESS"
					) {
						newLevel = levelIndex;
						break;
					}
				}
				this.currentLevel = parseInt(newLevel);
			}
		}
	}
};
</script>

<style scoped lang="scss">
@media screen and (max-width: 512px) {
	.main {
		padding: 0px;
	}
}
button:focus {
	outline: 0;
}
.dark {
	color: white;
}
.v-window {
	box-shadow: 0px 0px 4px rgba(7, 28, 80, 0.1);
}
.card-content {
	background: #ffffff;
	width: 100%;
	min-height: 110px;
	align-self: center;
	display: flex;
	.level {
		margin: 12px;
		width: 18%;
		padding: 12px;
		text-align: center;
		letter-spacing: 0.005em;
		font-weight: 600;
		color: #ffffff;
		background: linear-gradient(137.79deg, #af8dd3 0%, #395ed3 100%);
		border-radius: 4px;
		.level-number {
			font-size: 24px;
		}
		.level-text {
			font-size: 10px;
		}
	}
	.recharge-info {
		display: block;
		width: 52%;
		margin: 8px 0px 12px 0px;
		.recharge-info-text {
			font-style: normal;
			font-weight: 600;
			font-size: 12px;
			line-height: 140%;
			display: block;
			align-items: center;
			letter-spacing: 0.005em;
			color: #575f6b;
			.recharge-tagline {
				font-size: 10px;
				color: #828a97;
			}
		}
		.recharge-info-bar {
			margin-top: 14px;
			font-weight: normal;
			font-size: 10px;
			line-height: 130%;
			display: block;
			letter-spacing: 0.005em;
			color: #828a97;
			.progress-bar {
				margin: 2px;
				border-radius: 8px;
				width: 70%;
			}
		}
		.recharge-completed {
			margin-top: 14px;
			font-style: normal;
			font-weight: 600;
			font-size: 10px;
			line-height: 130%;
			align-items: center;
			letter-spacing: 0.005em;
			color: #2dbe8e;
		}
	}
	.rewards {
		float: right;
		width: 30%;
		font-size: 10px;
		text-align: right;
		letter-spacing: 0.005em;
		color: #828a97;
		overflow: hidden;
		.time-left {
			font-size: 10px;
			text-align: center;
			background: #ed4f5d;
			width: 81px;
			height: 16px;
			float: right;
		}
		.achieved {
			font-size: 10px;
			text-align: center;
			background: #2dbe8e;
			width: 81px;
			height: 16px;
			float: right;
		}
		.rewards-amount-container {
			display: block;
			margin-right: 12px;
			margin-top: 20px;
			.amount {
				color: #828a97;
				font-weight: 600;
				font-size: 20px;
				.inr-symbol {
					margin-right: 4px;
					vertical-align: middle;
					font-size: 14px;
				}
				.amount-value {
					font-size: 20px;
					color: #575f6b;
				}
			}
		}
		.recharge-button {
			margin-top: 4px;
			margin-right: 12px;
			padding: 3px 9px;
			color: white;
			text-align: center;
			font-size: 12px;
			background: #2dbe8e;
			border-radius: 4px;
		}
	}
}
/* Card-Actions */
.window-dot {
	height: 6px;
	width: 6px;
	border-radius: 50%;
	display: inline-block;
}
.window-dot.active {
	background: #205fb9;
	margin-left: 4px;
}
.window-dot.inactive {
	background: #c0c8d4;
	margin-left: 4px;
}
.navigate-button i {
	color: #575f6b;
}
</style>
